import React from "react";
import PropTypes from "prop-types";
import styles from "./OrderDetailsCard.module.css";

export function OrderDetailsCard({
  orderId,
  lastName,
  address,
  status,
  trackingNum,
  trackingUrl,
  subTotal,
  tax,
  gst,
  shipping,
  total,
  ccTransaction,
  ahTraceId,
  hcTraceId,
}) {
  // Show an em dash for fields we don't have a value for yet (e.g. tracking or
  // trace ids on an order that hasn't been fulfilled) so no row reads as blank.
  const show = (v) =>
    v === 0 || v === "0"
      ? v
      : v === "" || v === null || v === undefined
      ? "—"
      : v;

  return (
    <section className={styles.card}>
      <header className={styles.header}>
        <h3 className={styles.heading}>Order Details</h3>
      </header>

      <div className={styles.row}>
        <span className={styles.label}>Order ID</span>
        <span className={styles.value}>{show(orderId)}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Name</span>
        <span className={styles.value}>{show(lastName)}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Address</span>
        <span className={styles.value}>{show(address)}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Status</span>
        <span className={styles.value}>{show(status)}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Tracking Number</span>
        <span className={styles.value}>
          {trackingNum && /^https?:\/\//i.test(trackingUrl || "") ? (
            <a
              className={styles.link}
              href={trackingUrl}
              target="_blank"
              rel="noopener noreferrer"
              title="Open the carrier's tracking page."
            >
              {trackingNum}
            </a>
          ) : (
            show(trackingNum)
          )}
        </span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Subtotal</span>
        <span className={styles.value}>{show(subTotal)}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Tax</span>
        <span className={styles.value}>{show(tax)}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>GST</span>
        <span className={styles.value}>{show(gst)}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Shipping</span>
        <span className={styles.value}>{show(shipping)}</span>
      </div>
      <div className={`${styles.row} ${styles.totalRow}`}>
        <span className={styles.label}>Total</span>
        <span className={styles.value}>{show(total)}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>CC Transaction</span>
        <span className={styles.value}>{show(ccTransaction)}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>AH Trace ID</span>
        <span className={styles.value}>{show(ahTraceId)}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>HC Trace ID</span>
        <span className={styles.value}>{show(hcTraceId)}</span>
      </div>
    </section>
  );
}

OrderDetailsCard.propTypes = {
  orderId: PropTypes.string,
  lastName: PropTypes.string,
  address: PropTypes.string,
  status: PropTypes.string,
  trackingNum: PropTypes.string,
  trackingUrl: PropTypes.string,
  subTotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  gst: PropTypes.string,
  shipping: PropTypes.string,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ccTransaction: PropTypes.string,
  ahTraceId: PropTypes.string,
  hcTraceId: PropTypes.string,
};
